export default __webpack_public_path__ + "static/media/apple-black.01d7fb41.svg";